module.exports = __webpack_public_path__ + "img/individual_weddingrings_spread.9f08987.jpg";